import {
  Dimensions,
  FlatList,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  Image,
} from "react-native";
import React, { useState } from "react";
import { useAppSelector } from "../hooks/reduxHooks";
import { Discount } from "../store/slices/discountsSlice";
import CachedImage from "./CachedImage";
import { isic_get_card_microservice } from "../store/api";
import { Modal, Portal } from "react-native-paper";
import DiscountBanner from "./DiscountBanner";
export interface Filters {
  category?: string;
  region?: string;
  discountType?: string;
}

interface ExclusiveDiscountsProps {
  specific?: {
    filters: Filters;
    sort: "popular" | "new";
  };
}
const orderByMostPopular = (a: Discount, b: Discount) =>
  a.popularity < b.popularity ? 1 : -1;

const OrderByNewest = (a: Discount, b: Discount) => {
  return new Date(b.date).getTime() - new Date(a.date).getTime();
};
const pathUrl = `${isic_get_card_microservice}/users/discounts/`;
const ExclusiveDiscounts = ({ specific }: ExclusiveDiscountsProps) => {
  const discounts = useAppSelector((s) => s.discounts);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDiscount, setSelectedDiscount] = useState<Discount>();
  const handleDiscountClick = (disc: Discount) => {
    setSelectedDiscount(disc);
    setModalOpen(true);
  };

  const filteredDiscounts = specific
    ? discounts.filter((d) => {
        const isCategory = specific.filters.category
          ? d.category.includes(specific.filters.category)
          : true;
        const isRegion = specific.filters.region
          ? specific.filters.region === "Todas"
            ? true
            : d.region.includes(specific.filters.region)
          : true;
        const isDiscountType = specific.filters.discountType
          ? specific.filters.discountType === "Todas"
            ? true
            : d.discountType.includes(specific.filters.discountType)
          : true;
        return isCategory && isRegion && isDiscountType;
      })
    : discounts;

  const sortedDiscounts = [...filteredDiscounts].sort(
    !specific || specific.sort !== "popular"
      ? OrderByNewest
      : orderByMostPopular
  );

  return (
    <ScrollView contentContainerStyle={styles.scrollViewContianer}>
      {sortedDiscounts.map((disc) => {
        return (
          <TouchableOpacity
            style={styles.discount}
            key={disc.id}
            onPress={() => handleDiscountClick(disc)}
          >
            <CachedImage
              cacheKey={disc.imageId}
              source={{ uri: pathUrl + disc.imageId }}
              style={styles.discountImage}
            />
            {/*   <Image
              source={{ uri: pathUrl + disc.imageId }}
              style={styles.discountImage}
            /> */}
            <Text style={styles.discountName}>{disc.name}</Text>
            <Text style={styles.discountDesc}>{disc.description}</Text>
          </TouchableOpacity>
        );
      })}
      <Portal>
        <Modal visible={modalOpen}>
          {selectedDiscount && (
            <DiscountBanner
              close={() => setModalOpen(false)}
              info={selectedDiscount}
            />
          )}
        </Modal>
      </Portal>
    </ScrollView>
  );
};

export default ExclusiveDiscounts;

const styles = StyleSheet.create({
  scrollViewContianer: {
    flexWrap: "wrap",
    flexDirection: "row",
    width: "90%",
    marginBottom: 70,
    marginHorizontal: "5%",
    alignItems: "stretch",
  },

  discount: {
    width: "50%",

    alignItems: "center",
  },
  discountImage: {
    height:
      Dimensions.get("screen").width / 2 -
      (Dimensions.get("screen").width / 100) * 6.25,
    width: "95%",
    borderRadius: 15,
  },
  discountName: {
    fontSize: 16,
    marginTop: 8,
  },
  discountDesc: {
    fontSize: 16,
    fontWeight: "700",
    marginBottom: 10,
    lineHeight: 22,
  },
});
